import React from 'react';
import Typography from '@mui/material/Typography';
import { Breadcrumbs as BreadcrumbsUI } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import GrainIcon from '@mui/icons-material/Grain';
import Box from '@mui/material/Box';
import { Link as LinkUI } from 'react-router-dom';
import { styled } from '@mui/material/styles';

const StyledBreadcrumbs = styled(BreadcrumbsUI)(({ theme , light }) => ({
    '& ol': {
        padding: 0,
        margin: 0,
        listStyle: 'none',
        display: 'flex',
        alignItems: 'center',
    },
    '& li': {
        display: 'flex',
        alignItems: 'center',
        '& a, & p': {
            color: light ? theme.palette.text.secondary : theme.palette.text.primary,
            fontSize: '0.85rem',
        },
    },
    '& svg': {
        marginRight: theme.spacing(0.5),
        width: 15,
        height: 15,
    },
}));

const Link = styled(LinkUI)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.85rem',
    color: theme.palette.text.primary,
    textDecoration: 'none',
    '&:hover': {
        textDecoration: 'underline',
    },
}));

export const Breadcrumbs = ({ items = [], light = false }) => {
    const crumbs = {
        DASHBOARD: { label: 'Dashboard', link: '/dashboard' },
        MONITOR: { label: 'Monitor', link: '/monitor' },
        BUSINESS: { label: 'Tenant', link: '/business' },
        HALLS: { label: 'Halls', link: '/halls' },
        MEETING_ROOMS: { label: 'Meeting Rooms', link: '/meeting-rooms' },
        CONFERENCE_ROOMS: { label: 'Conference Rooms', link: '/conference-rooms' },
        RESERVATION: { label: 'Reservations', link: '/reservations' },
        RESOURCES: { label: 'Resources', link: '/resources' },
        USER: { label: 'Users', link: '/users' },
        ROLE: { label: 'Roles', link: '/roles' },
        PERMISSION: { label: 'Permissions', link: '/permissions' },
        NOTIFICATION: { label: 'Notifications', link: '/notifications' },
        SETTING: { label: 'Settings', link: '/settings' },
        PROFILE: { label: 'Profile', link: '/profile' },
        REPORTS: { label: 'Reports', link: '/reports' },
        SETTINGS: { label: 'Settings', link: '/settings' },
        ROSTERS: { label: 'Rosters', link: '/rosters' },
        DEPARTMENTS: { label: 'Departments', link: '/departments' },
        ROSTER: { label: 'Roster', link: '/roster' },
        CALENDAR: { label: 'Calendar', link: '/roster/calendar' },
        THEMES: { label: 'Themes', link: '/themes' },
    };

    const renderIcon = (index) => {
        return index === 0 ? <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" /> : <GrainIcon sx={{ mr: 0.5 }} fontSize="inherit" />;
    };

    return (
        <Box role="presentation" sx={{ display: 'flex', alignItems: 'center' }}>
            <StyledBreadcrumbs aria-label="breadcrumb" light={"light"}>
                {items.map((item, index) => {
                    const crumb = crumbs[item] || { label: item };

                    return index === items.length - 1 ? (
                        <Typography key={index} sx={{ display: 'flex', alignItems: 'center' }} color="text.primary">
                            {renderIcon(index)}
                            {crumb.label}
                        </Typography>
                    ) : (
                        crumb.link ? (
                            <Link key={index} to={crumb.link}>
                                {renderIcon(index)}
                                {crumb.label}
                            </Link>
                        ) : (
                            <Typography key={index} sx={{ display: 'flex', alignItems: 'center' }} color="text.primary">
                                {renderIcon(index)}
                                {crumb.label}
                            </Typography>
                        )
                    );
                })}
            </StyledBreadcrumbs>
        </Box>
    );
};
